export default {
  name: 'CourseCreationChecklist',
  props: ['course_slug', 'course_creation_progress'],
  template: '#course_creation_checklist',
  data () {
    return {
      steps: [{
        icon: this.course_creation_progress.syllabus_created ? 'kf-checkmark' : 'kf-course-info',
        title: `Create Your ${Kadenze.I18n.n('syllabus')}` ,
        subtitle:  Kadenze.I18n.t('course_creation_checklist.create_sylabus_subtitle'),
        btn_link: Kadenze.Routes.edit_course_path(this.course_slug),
        btn_text: `${this.course_creation_progress.syllabus_created ? 'Edit' : 'Create'} ${Kadenze.I18n.n('syllabus')}`
      },
      {
        icon: this.course_creation_progress.lectures_created ? 'kf-checkmark' : 'kf-sessions',
        title: Kadenze.I18n.t('course_creation_checklist.create_session_title'),
        subtitle: Kadenze.I18n.t('course_creation_checklist.create_session_subtitle'),
        btn_link: Kadenze.Routes.new_course_session_path(this.course_slug),
        btn_text: Kadenze.I18n.t('course_creation_checklist.create_session_btn_text')
      },
      {
        icon: this.course_creation_progress.coursework_created ? 'kf-checkmark' : 'kf-coursework',
        title: Kadenze.I18n.t('course_creation_checklist.create_coursework_title'),
        subtitle: Kadenze.I18n.t('course_creation_checklist.create_coursework_subtitle'),
        btn_link: Kadenze.Routes.new_course_coursework_path(this.course_slug),
        btn_text: Kadenze.I18n.t('course_creation_checklist.create_coursework_title')
      },
      {
        icon: 'kf-publish',
        title: Kadenze.I18n.t('course_creation_checklist.publish_course_title'),
        subtitle: Kadenze.I18n.t('course_creation_checklist.publish_course_subtitle'),
        btn_link: Kadenze.Routes.course_settings_path(this.course_slug),
        btn_text: Kadenze.I18n.t('course_creation_checklist.publish_course_title')
      }
      ]
    };
  }
};
